"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var Observable_1 = require("rxjs/Observable");
var icon_picker_config_1 = require("./icon-picker-config");
var IconPickerService = /** @class */ (function () {
    function IconPickerService(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    IconPickerService.prototype.getIcons = function () {
        var _this = this;
        return combineLatest_1.combineLatest(this.urls.map(function (url) {
            return Observable_1.Observable.of({
                httpCall: _this.http.get(url, {
                    headers: new http_1.HttpHeaders().set('Content-Type', 'text/xml'),
                    responseType: 'text'
                }),
                url: url
            });
        }));
    };
    IconPickerService = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject(icon_picker_config_1.ICON_PATH_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Array])
    ], IconPickerService);
    return IconPickerService;
}());
exports.IconPickerService = IconPickerService;
//# sourceMappingURL=icon-picker.service.js.map